<script setup lang="ts">
import type { userDataApi } from '@/entities/user-data'
import { GlobusIcon, RussianIcon, TrashIcon } from '@/shared/icons'
import MoreIcon from '@/shared/icons/MoreIcon.vue'
import { formatCarNumber, transliterateCarNumber } from '@/shared/lib/formatting'
import { MtdButton, MtdContainer, MtdPopover, MtdTypography } from '@paygine/mtd-uikit'
import { ref } from 'vue'

const props = defineProps<{
    transport: userDataApi.Grn
}>()

const emit = defineEmits<{
    'transport:delete': [userDataApi.Grn]
}>()

const isActionVisible = ref(false)

function handleDelete(transport: userDataApi.Grn) {
    emit('transport:delete', transport)
    isActionVisible.value = false
}
</script>

<template>
    <MtdContainer
        class="transport-item"
        :is-active="true"
    >
        <div class="transport-item__icon">
            <RussianIcon v-if="transport.grn_country === 'RUS'" />
            <GlobusIcon v-else />
        </div>

        <MtdTypography
            tag="span"
            class="transport-item__name"
            variant="textbody-2-medium"
            >{{
                transport.grn_country === 'RUS'
                    ? formatCarNumber(transliterateCarNumber(transport.grn, 'latin-to-cyrillic'))
                    : transport.grn
            }}</MtdTypography
        >

        <MtdPopover
            v-model="isActionVisible"
            trigger="click"
            position="bottom-end"
            :offset="12"
            :alignment-offset="-8"
            class="transport-item__action-trigger"
            container-class="transport-item__actions"
            content-class="transport-item__actions-content"
        >
            <template #control="slotProps">
                <MtdButton
                    v-bind="slotProps"
                    size="xs"
                    type="button"
                    variant="main-white"
                    class="transport-item__action-button"
                >
                    <MoreIcon />
                </MtdButton>
            </template>

            <template #content>
                <MtdButton
                    type="button"
                    variant="danger-flat"
                    class="transport-item__delete"
                    size="sm"
                    @click="handleDelete(transport)"
                >
                    <template #icon>
                        <TrashIcon />
                    </template>
                    Удалить
                </MtdButton>
            </template>
        </MtdPopover>
    </MtdContainer>
</template>

<style src="./TransportListItem.scss" lang="scss"></style>
